import type { ComponentType } from "react"
import CampaignChannelsArticle from "./articles/campaign-channels.mdx"
import ConnectProvidersArticle from "./articles/connect-providers.mdx"
import ConversionValuesArticle from "./articles/conversion-values.mdx"
import InstallTrackingArticle from "./articles/install-tracking.mdx"
import ManualEventsArticle from "./articles/manual-events.mdx"
import TroubleshootingArticle from "./articles/troubleshooting.mdx"

export type DocsArticle = {
  slug: string
  section: string
  title: string
  description: string
  tags: string[]
  component: ComponentType
}

export const docsArticles: DocsArticle[] = [
  {
    slug: "install-tracking",
    section: "Tracking",
    title: "Install the tracking tag",
    description: "Add the Adgiro site tag and confirm that website events are flowing.",
    tags: ["tag", "setup"],
    component: InstallTrackingArticle,
  },
  {
    slug: "manual-events",
    section: "Tracking",
    title: "Send manual events",
    description: "Use window.adgiroEvent for events your site knows better than the tracker.",
    tags: ["events", "javascript"],
    component: ManualEventsArticle,
  },
  {
    slug: "conversion-values",
    section: "Tracking",
    title: "Forward conversion values",
    description: "Send explicit value, currency, and transaction IDs to providers.",
    tags: ["value", "currency"],
    component: ConversionValuesArticle,
  },
  {
    slug: "connect-providers",
    section: "Accounts",
    title: "Connect Google and Meta",
    description: "Link provider accounts while keeping app auth separate from provider auth.",
    tags: ["google", "meta"],
    component: ConnectProvidersArticle,
  },
  {
    slug: "campaign-channels",
    section: "Campaigns",
    title: "Launch and manage campaign channels",
    description: "Understand channel rows, budgets, launch, pause, resume, and provider sync.",
    tags: ["campaigns", "channels"],
    component: CampaignChannelsArticle,
  },
  {
    slug: "troubleshooting",
    section: "Operations",
    title: "Troubleshoot setup and launches",
    description: "Diagnose tracking, provider account, launch, and validation issues.",
    tags: ["errors", "ops"],
    component: TroubleshootingArticle,
  },
]

export const docsSections = Array.from(new Set(docsArticles.map((article) => article.section)))
